import styled from "styled-components";

export const SkipLinksContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999;
`;

export const SkipLink = styled.a`
  position: absolute;
  left: -9999px;

  background: #000;
  color: #fff;

  padding: 12px 16px;

  text-decoration: none;
  font-weight: 600;

  border-radius: 4px;

  &:focus {
    left: 16px;
    top: 16px;
  }
`;